export {default as StarRating, Classes} from './StarRating';
